"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._Encryption = {
    type: "structure",
    required: ["EncryptionType"],
    members: {
        EncryptionType: {
            shape: {
                type: "string"
            }
        },
        KMSKeyId: {
            shape: {
                type: "string",
                sensitive: true
            }
        },
        KMSContext: {
            shape: {
                type: "string"
            }
        }
    }
};
//# sourceMappingURL=_Encryption.js.map